import React, { Component } from 'react';
import mem1 from '../assets/member1.JPG';
import mem2 from '../assets/member2.JPG';
import mem3 from '../assets/member4.JPG';
import mem4 from '../assets/member3.JPG';
import mem5 from '../assets/member6.JPG';
import mem6 from '../assets/member7.JPG';

class Team extends Component {

    render() {
        return (

            <div className='teamMain'>
                <div class="teamBlur">

                    <div class="conT" data-aos="zoom-in" data-aos-duration="700">Team Members</div>

                    <div className='team'>
                        <div className='member'>
                            <img src={mem1} />
                            <div className='name'>Jang Young-Hyun</div>
                            <div className='position'>Chairman of Technology Committee</div>
                        </div>

                        <div className='member'>
                            <img src={mem2} />
                            <div className='name'>Cho Young-Jun</div>
                            <div className='position'>Chairman of Acting Committee</div>
                        </div>

                        <div className='member'>
                            <img src={mem3} />
                            <div className='name'>Hwang Hun</div>
                            <div className='position'>Chairman of Media Committee</div>
                        </div>

                    </div>

                    <div className='team'>
                        <div className='member'>
                            <img src={mem4} />
                            <div className='name'>Jenny An</div>
                            <div className='position'>Chairman of Modeling Committee</div>
                        </div>

                        <div className='member'>
                            <img src={mem5} />
                            <div className='name'>Jang Byung-Un</div>
                            <div className='position'>Chairman of Legal Committee</div>
                        </div>

                        <div className='member'>
                            <img src={mem6} />
                            <div className='name'>Moon Dae-Sung</div>
                            <div className='position'>Chairman of Taekwondo Committee</div>
                        </div>

                    </div>

                </div>

            </div>

        );
    }
}

export default Team;        